const BREAKPOINTS = {
  sm: 576, // 36rem
  md: 768, // 48rem
  lg: 992, // 62rem
  xl: 1200, // 75rem
};

export default BREAKPOINTS;
